import { Outlet } from "react-router-dom";

const DetailDeviceLayout = function () {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default DetailDeviceLayout;
